import { dwInit } from '@/utils/dw-collect';
import { configApi } from './api';
import { configClassNameByEnv } from './class-name-by-env';
import { configWpsClient } from './client';
import { configGlobalProperties } from './global-properties';
import type { ConfigMainParams } from './types';
import { configUtils } from './utils';

export function configMain({ app }: ConfigMainParams) {
  // 配置工具库
  configUtils();
  // 配置api
  configApi();
  // 配置全局对象
  configGlobalProperties();
  // 配置客户端
  configWpsClient();
  // 配置环境类名
  configClassNameByEnv(document.body, 'lowcode-body');
  // 数仓初始化
  dwInit();
}
